import { useFeatureFlags } from "@/configs/featureFlag";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MyPage } from "@/features/mypage/routes/Mypage";

export const MypageRoutes: React.FC = () => {
  const { mypageTop } = useFeatureFlags();

  return (
    <Routes>
      {mypageTop ? <Route path="" element={<MyPage />} /> : null}
      <Route path="*" element={<Navigate to="" />} />
    </Routes>
  );
};
